import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Card,
  Center,
  Checkbox,
  ComboboxItem,
  Flex,
  Group,
  Loader,
  Menu,
  Modal,
  NumberFormatter,
  NumberInput,
  Select,
  Table,
  Text,
  TextInput,
  Textarea,
  Title,
  Tooltip,
} from "@mantine/core";
import { hasLength, useForm } from "@mantine/form";
import {
  getHotkeyHandler,
  useClickOutside,
  useDebouncedState,
  useHotkeys,
} from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconArrowBigUp,
  IconArrowLeft,
  IconCheck,
  IconPlus,
  IconRefresh,
  IconTrash,
} from "@tabler/icons-react";
import dayjs from "dayjs";
import {
  MRT_ColumnDef,
  MRT_Row,
  MRT_RowSelectionState,
  MantineReactTable,
  useMantineReactTable,
} from "mantine-react-table";
import * as React from "react";
import { useCallback, useEffect, useState } from "react";
import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";
import { useLocation, useNavigate } from "react-router-dom";
import * as xlsx from "xlsx";
import {
  repositoryDelivery,
  repositoryMdm,
  repositoryPos,
} from "../../../_base/_const/_constVar";
import { WAREHOUSE_DATA } from "../../Sell/RetailOrder/ModalComponent/constants/warehouseData";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { getValueById } from "../../../_base/helper/FunctionHelper";
import { styleCellTable } from "../../../_setup/navdata/baseStyleCellTable";
import { formatDateTransfer } from "../../../common/FormatDate/FormatDate";
import { MessageResponse } from "../../../model/MessageResponse";
import { itemSearchTrasferModel } from "../../../model/TblDMItem";
import { TblDmEmployeeModel } from "../../../model/TblDmEmployeeModel";
import {
  tblDmRequestTransferDetailCommands,
  tblRequestTransfer,
} from "../../../model/TblRequestTransfer";
import { getBranchSelect } from "../../../service/getSelectApi";
import { RequestTransferStatus } from "../requestTransferStatus";
import { DemoExportRequestTransfer } from "./DemoExportRequestTransfer";
import DropZoneFile from "./DropZoneFile";
import ReviewDataImport from "./ReviewDataImport";

interface TableSelectProps {
  dataProducts: itemSearchTrasferModel[];
  onSelectProduct: (product: itemSearchTrasferModel) => void;
  rowIndex: any;
}

interface TableSelectCustomerProps {
  dataCustomer: TblDmEmployeeModel[];
  onSelectCustomer: (customer: TblDmEmployeeModel) => void;
  rowIndex: any;
  // onEditingRowSave: MRT_TableOptions<dataOrderDetailTable>["onEditingRowSave"];
  selectEmployee: number;
}

export interface dataOrderDetailTable extends tblDmRequestTransferDetailCommands {
  itemName: string;
  requestByName: string;
  itemCode: string;
  virtualQuantity?: number;
  actualQuantity?: number;
  fromSubInvOrgName: string | null;
  poPrice: number;
}

const CreateRequestTransfer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dataSerial = location.state;
  const typeRequestTransfer =
    location.state && location.state?.typeRequestTransfer;

  const [dataRequestTransfer, setDataRequestTransfer] =
    useState<tblRequestTransfer>({
      id: 0,
      code: "",
      note: "",
      deliveryPriorityLevel: "",
      deliveryTime: "",
      deliveryDepartmentId: 0,
      deliveryPersonId: 0,
      attribute1: null,
      attribute2: null,
      attribute3: null,
      attribute4: null,
      attribute5: null,
      attribute6: null,
      attribute7: null,
      attribute8: null,
      attribute9: null,
      attribute10: null,
      attribute11: null,
      attribute12: null,
      attribute13: null,
      attribute14: null,
      attribute15: null,
      approve: false,
      branchId: 0,
      fromBranchId: 0,
      fromBranchName: null,
      fromInvId: 0,
      fromInvName: null,
      toBranchId: 0,
      toBranchName: null,
      toInvId: 0,
      toInvName: null,
      statusCode: null,
      statusid: null,
      requestDate: null,
      finishDate: null,
      createDate: null,
      createBy: null,
      lastUpdatedDate: null,
      updatedBy: null,
      addedDate: null,
      type: null,
      empRoleId: null,
      empRoleName: null,
      empDepartmentId: null,
      empDepartmentName: null,
      empBranchId: null,
      fromEmpId: null,
      fromDepartmentId: null,
      fromRoleId: null,
      toEmpId: null,
      toDepartmentId: null,
      toRoleId: null,
      deliveryMethodCode: null,
      totalAmount: null,
      totalQuantity: null,
      active: null,
      tblDmRequestTransferDetailCommands: [],
    });
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [disabledButton, setDisabledButton] = useState(false);
  const [finish, setFinish] = useState(false);
  //table state
  const [detailFromBranch, setDetailFromBranch] = useState<string | null>(null);
  const [detailToBranch, setDetailToBranch] = useState<string | null>(null);
  const [listAdd, setListAdd] = useState<dataOrderDetailTable[]>([]);
  const [selectedProducts, setSelectedProducts] = useState<Set<any>>(new Set());
  const [validationErrors, setValidationErrors] = useState<
    Record<string, string | undefined>
  >({});
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [dataProducts, setDataProducts] = useState<any[]>([]);
  const [selectedCustomer, setSelectedCustomer] = useState<{
    requestBy: number | null;
    requestByName: string;
  }>({
    requestBy: null,
    requestByName: "",
  });
  const [dataInventory, setDataInventory] = useState<{
    formInv?: any;
    toInv?: any;
  }>();
  const [dataBranch, setDataBranch] = useState<ComboboxItem[]>([]);
  const [dataReasonRequestTransfer, setDataReasonRequestTransfer] = useState<
    ComboboxItem[]
  >([]);
  const [dataEmpToBranch, setDataEmpToBranch] = useState<ComboboxItem[]>([]);
  const [dataEmployeeManagerItem, setDataEmployeeManagerItem] = useState<any[]>(
    [],
  );
  const [dataDepAndRole, setDataDepAndRole] = useState<any[]>([]);
  const [dataVendorSelect, setDataVendorSelect] = useState<ComboboxItem[]>([]);
  const [dataVendorId, setDataVendorId] = useState<any[]>([]);
  const [rowIndex, setRowIndex] = useState(0);
  const [typeInv, setTypeInv] = useState("");
  const [dataCreateDate, setDataCreateDate] = useState<string | null>(null);
  const [ghtkEstimatedFee, setGhtkEstimatedFee] = useState<number | null>(null);
  const [isLoadingGhtkFee, setIsLoadingGhtkFee] = useState<boolean>(false);

  const GHTK_CONFIG = {
    token: "3f6b91c82ddfc29e8e53b6b21a0b5fdf35d1d8e7",
    defaultWeight: "1000",
    defaultValue: 100000,
    deliveryOption: "none",
  };

  const fetchGhtkEstimatedFee = useCallback(async () => {
    if (
      dataRequestTransfer.attribute1 !== "GHTK" ||
      !dataRequestTransfer.fromBranchId ||
      !dataRequestTransfer.toBranchId
    ) {
      setGhtkEstimatedFee(null);
      return;
    }

    const warehouseFrom = WAREHOUSE_DATA.find(
      (w) => w.id === Number(dataRequestTransfer.fromBranchId)
    );
    const warehouseTo = WAREHOUSE_DATA.find(
      (w) => w.id === Number(dataRequestTransfer.toBranchId)
    );

    let pickProvince = warehouseFrom?.pick_province || "";
    let pickDistrict = warehouseFrom?.pick_district || "";
    let toAddress = warehouseTo?.pick_address || "";
    let toProvince = warehouseTo?.pick_province || "";
    let toDistrict = warehouseTo?.pick_district || "";

    if (!pickProvince || !toProvince) {
      try {
        if (!pickProvince) {
          const resFrom = await repositoryDelivery.get<MessageResponse<any>>(
            `/api/v1/TblDMMasterOrg/detail?id=${dataRequestTransfer.fromBranchId}`
          );
          if (resFrom?.data) {
            pickProvince = resFrom.data.attribute8 || resFrom.data.province || "";
            pickDistrict = resFrom.data.attribute9 || resFrom.data.district || "";
          }
        }
        if (!toProvince) {
          const resTo = await repositoryDelivery.get<MessageResponse<any>>(
            `/api/v1/TblDMMasterOrg/detail?id=${dataRequestTransfer.toBranchId}`
          );
          if (resTo?.data) {
            toAddress = resTo.data.address || toAddress;
            toProvince = resTo.data.attribute8 || resTo.data.province || "";
            toDistrict = resTo.data.attribute9 || resTo.data.district || "";
          }
        }
      } catch (err) {
        console.error("Lỗi lấy thông tin chi nhánh:", err);
      }
    }

    if (!pickProvince || !toProvince) {
      return;
    }

    try {
      setIsLoadingGhtkFee(true);
      const orderValue =
        dataRequestTransfer.totalAmount && dataRequestTransfer.totalAmount > 0
          ? dataRequestTransfer.totalAmount
          : GHTK_CONFIG.defaultValue;

      const queryParams = new URLSearchParams({
        address: toAddress || `${toDistrict}, ${toProvince}`,
        province: toProvince,
        district: toDistrict || toProvince,
        pick_province: pickProvince,
        pick_district: pickDistrict || pickProvince,
        weight: GHTK_CONFIG.defaultWeight,
        value: orderValue.toString(),
        deliver_option: GHTK_CONFIG.deliveryOption,
        token: GHTK_CONFIG.token,
      });

      const response = await repositoryDelivery.get<any>(
        `/api/v1/GhtkIntegration/fee?${queryParams.toString()}`
      );

      if (response && response.success && response.fee) {
        const feeVal =
          typeof response.fee === "object" && response.fee !== null
            ? response.fee.fee
            : response.fee;
        setGhtkEstimatedFee(Number(feeVal) || 0);
      } else {
        setGhtkEstimatedFee(null);
      }
    } catch (error) {
      console.error("Lỗi tính phí GHTK:", error);
      setGhtkEstimatedFee(null);
    } finally {
      setIsLoadingGhtkFee(false);
    }
  }, [
    dataRequestTransfer.attribute1,
    dataRequestTransfer.fromBranchId,
    dataRequestTransfer.toBranchId,
    dataRequestTransfer.totalAmount,
  ]);

  useEffect(() => {
    if (
      dataRequestTransfer.attribute1 === "GHTK" &&
      dataRequestTransfer.fromBranchId &&
      dataRequestTransfer.toBranchId
    ) {
      fetchGhtkEstimatedFee();
    } else if (dataRequestTransfer.attribute1 !== "GHTK") {
      setGhtkEstimatedFee(null);
    }
  }, [
    dataRequestTransfer.attribute1,
    dataRequestTransfer.fromBranchId,
    dataRequestTransfer.toBranchId,
    dataRequestTransfer.totalAmount,
    fetchGhtkEstimatedFee,
  ]);
  //#region  table
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [opened, setOpened] = useState(true);
  //#region  import excel
  const [workbook, setWorkbook] = useState<xlsx.WorkBook | null>(null);
  const [sheetNames, setSheetNames] = useState<string[]>([]);
  const [selectedSheets, setSelectedSheets] = useState<string[]>([]);
  const [openModals, setOpenModal] = useState(false);
  const dataTypeSelect = [
    {
      label: "Điều chuyển chi nhánh (SL)",
      value: "DIEU_CHUYEN_CHI_NHANH",
      type: 1,
    },
    {
      label: "Điều chuyển chi nhánh serial",
      value: "DIEU_CHUYEN_CHI_NHANH_SERIAL",
      type: 1,
    },
    {
      label: "Điều chuyển nội bộ (SL)",
      value: "DIEU_CHUYEN_NOI_BO",
      type: 2,
    },
    {
      label: "Điều chuyển nội bộ serial",
      value: "DIEU_CHUYEN_NOI_BO_SERIAL",
      type: 2,
    },
    {
      label: "Xuất kho hủy",
      value: "XUAT_HUY",
      type: 1,
    },
    {
      label: "Xuất kho điều chỉnh",
      value: "XUAT_DIEU_CHINH",
      type: 1,
    },
    {
      label: "Xuất công cụ/dụng cụ",
      value: "XUAT_CONG_CU_DUNG_CU",
      type: 1,
    },
  ];

  const form = useForm<tblRequestTransfer>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      ...dataRequestTransfer,
    },

    validate: {
      fromBranchId: (value: number | null, values) => {
        if (!value) {
          return "Vui lòng chọn chi nhánh !";
        }
      },
      fromInvId: (value: number | null) => {
        if (!value) {
          return "Vui lòng chọn kho !";
        }
      },
      toBranchId: (value: number | null, values) => {
        if (!value && values.type !== "XUAT_TRA_NCC") {
          return "Vui lòng chọn chi nhánh !";
        }
      },
      toInvId: (value: number | null, values) => {
        if (
          !value &&
          values.type !== "XUAT_HUY" &&
          values.type !== "XUAT_DIEU_CHINH" &&
          values.type !== "XUAT_TRA_NCC"
        ) {
          return "Vui lòng chọn kho !";
        }
      },
      attribute2: (value: string | null | undefined, values) => {
        if (!value && values.type === "XUAT_TRA_NCC") {
          return "Vui lòng chọn nhà cung cấp !";
        }
      },
      note: (value: string | null) => {
        if (value) {
          return hasLength(
            { max: 300 },
            "Ghi chú không được vượt quá 300 kí tự",
          )(value as string);
        }
      },
      attribute15: (value: string | null | undefined, values) => {
        if (
          (values.attribute1 === "GHTK" || values.attribute1 === "KHO") &&
          !value
        ) {
          return "Vui lòng chọn người nhận hàng !";
        }
      },
    },
  });

  const handleImportExcel = async (file: any) => {
    if (!file) {
      NotificationExtension.Fails("Vui lòng chọn lại tệp !");
      return;
    } else {
      modals.closeAll();
      NotificationExtension.Success("Import excel thành công !");
    }

    const fileReader = new FileReader();
    fileReader.onload = async (e) => {
      const data = e.target?.result;
      if (data) {
        const workbook = xlsx.read(data, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        let worksheet = workbook.Sheets[sheetName];
        if (
          dataRequestTransfer.type === "DIEU_CHUYEN_CHI_NHANH" ||
          dataRequestTransfer.type === "DIEU_CHUYEN_NOI_BO" ||
          dataRequestTransfer.type === "XUAT_CONG_CU_DUNG_CU"
        ) {
          worksheet = xlsx.utils.sheet_add_aoa(worksheet, [
            [
              "itemCode",
              "itemName",
              "primaryUom",
              "primaryQuantity",
              "subUom",
              "subQuantity",
              "status",
              "note",
            ],
          ]);
        } else {
          worksheet = xlsx.utils.sheet_add_aoa(worksheet, [
            [
              "serial",
              "itemCode",
              "itemName",
              "primaryUom",
              "primaryQuantity",
              "subUom",
              "subQuantity",
              "poPrice",
              "status",
              "note",
            ],
          ]);
        }
        setTimeout(() => {
          reviewDataImport();
        }, 1000);
      }
    };
    fileReader.readAsBinaryString(file);
  };

  const handleOpenFileDrop = () => {
    try {
      modals.openConfirmModal({
        title: null,
        withCloseButton: false,
        children: <DropZoneFile onImport={handleImportExcel}></DropZoneFile>,
        confirmProps: { display: "none" },
        cancelProps: { display: "none" },
      });
    } catch (e) {
      NotificationExtension.Fails("Import excel thất bại");
    }
  };

  function reviewDataImport() {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Đối chiếu tồn kho !</Title>
        </>
      ),
      size: "auto",
      children: <ReviewDataImport type={dataRequestTransfer.type} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  const mainRequestTransfer = () => {
    const tbHeader = (
      <Table.Tr>
        <Table.Th style={{ width: "25%" }}></Table.Th>
        <Table.Th style={{ width: "25%" }}>
          <Center>Yêu cầu xuất kho</Center>{" "}
        </Table.Th>
        <Table.Th style={{ width: "25%" }}>
          <Center>Bên xuất</Center>{" "}
        </Table.Th>
        <Table.Th style={{ width: "25%" }}>
          <Center>Bên nhận</Center>
        </Table.Th>
      </Table.Tr>
    );

    const tbBody = (
      <>
        <Table.Tr>
          <Table.Td>
            <Text fw={700} size="sm">
              Thời gian tạo
            </Text>
          </Table.Td>
          <Table.Td>
            <Text size="xs">{formatDateTransfer(dataCreateDate)}</Text>
          </Table.Td>
          <Table.Td></Table.Td>
          <Table.Td
            rowSpan={dataRequestTransfer.type !== "XUAT_TRA_NCC" ? 1 : 10}
          >
            {dataRequestTransfer.type === "XUAT_TRA_NCC" ? (
              <>
                <TextInput
                  label="Mã nhà cung cấp"
                  placeholder="Mã nhà cung cấp"
                  value={dataRequestTransfer.attribute2 ?? ""}
                  size="xs"
                  readOnly
                  variant="filled"
                  mt={-60}
                />
                <Select
                  label="Tên nhà cung cấp"
                  placeholder="Nhập tên nhà cung cấp"
                  data={dataVendorSelect}
                  value={
                    form.getValues().attribute2
                      ? form.getValues().attribute2
                      : null
                  }
                  searchable
                  clearable
                  nothingFoundMessage="Không tìm thấy dữ liệu !"
                  size="xs"
                  mt={30}
                  {...form.getInputProps("attribute2")}
                  onChange={(e) => {
                    handleChangeValueInput(e, "attribute2");
                    handleChangeValueInput(
                      getValueById(e ?? "", dataVendorSelect, "label"),
                      "attribute6",
                    );
                    handleChangeValueInput(
                      Number(getValueById(e ?? "", dataVendorId, "label")),
                      "attribute11",
                    );
                    form.setValues((prev) => ({
                      ...prev,
                      attribute2: e ? e?.toString() : null,
                      attribute6: e
                        ? getValueById(e, dataVendorSelect, "label")
                        : null,
                      attribute11: e
                        ? Number(getValueById(e, dataVendorId, "label"))
                        : null,
                    }));
                  }}
                />
              </>
            ) : (
              <></>
            )}
          </Table.Td>
        </Table.Tr>
        <Table.Tr>
          <Table.Td>
            <Text fw={700} size="sm">
              Thời gian hoàn thành
            </Text>
          </Table.Td>
          <Table.Td>
            {dataRequestTransfer.finishDate && (
              <Text size="xs">
                {formatDateTransfer(
                  new Date(dataRequestTransfer.finishDate ?? ""),
                )}
              </Text>
            )}
          </Table.Td>
          <Table.Td></Table.Td>
          {dataRequestTransfer.type !== "XUAT_TRA_NCC" ? (
            <Table.Td></Table.Td>
          ) : (
            <></>
          )}
        </Table.Tr>
        <Table.Tr>
          <Table.Td>
            <Text fw={700} size="sm">
              Mã yêu cầu xuất kho
            </Text>
          </Table.Td>
          <Table.Td>
            {dataRequestTransfer.type !== null ? (
              <Text size="xs">{dataRequestTransfer.code}</Text>
            ) : (
              <></>
            )}
          </Table.Td>
          <Table.Td></Table.Td>
          {dataRequestTransfer.type !== "XUAT_TRA_NCC" ? (
            <Table.Td></Table.Td>
          ) : (
            <></>
          )}
        </Table.Tr>
        <Table.Tr>
          <Table.Td>
            <Text fw={700} size="sm">
              Chi nhánh
            </Text>
          </Table.Td>
          <Table.Td>
            <Text size="xs">{dataRequestTransfer?.empBranchName}</Text>
          </Table.Td>
          <Table.Td>
            <Select
              searchable
              clearable
              disabled={listAdd.length > 0 || dataRequestTransfer.type === null}
              size="xs"
              placeholder="Chọn chi nhánh"
              withAsterisk
              nothingFoundMessage={"Không có dữ liệu"}
              data={
                dataRequestTransfer.type !== "DIEU_CHUYEN_NOI_BO" &&
                dataRequestTransfer.type !== "DIEU_CHUYEN_NOI_BO_SERIAL" &&
                dataRequestTransfer.type !== "XUAT_CONG_CU_DUNG_CU"
                  ? dataBranch?.filter(
                      (item: any) =>
                        item.value !==
                        dataRequestTransfer.toBranchId?.toString(),
                    )
                  : dataBranch
              }
              value={
                dataRequestTransfer.fromBranchId
                  ? dataRequestTransfer.fromBranchId?.toString()
                  : null
              }
              comboboxProps={{ width: 225 }}
              {...form.getInputProps("fromBranchId")}
              onChange={(value, option) => {
                handleChangeValueInput(Number(value) || "", "fromBranchId");
                handleChangeValueInput("", "fromInvId");
                form.setValues((prev) => ({
                  ...prev,
                  fromBranchId: Number(value),
                }));
                if (
                  dataRequestTransfer.type === "DIEU_CHUYEN_NOI_BO" ||
                  dataRequestTransfer.type === "DIEU_CHUYEN_NOI_BO_SERIAL" ||
                  dataRequestTransfer.type === "XUAT_CONG_CU_DUNG_CU"
                ) {
                  handleChangeValueInput(value || "", "toBranchId");
                  form.setValues((prev) => ({
                    ...prev,
                    toBranchId: Number(value),
                    toEmpId: null,
                  }));
                }
              }}
            />
          </Table.Td>
          {dataRequestTransfer.type !== "XUAT_TRA_NCC" ? (
            <Table.Td>
              <Select
                searchable
                size="xs"
                placeholder="Chọn chi nhánh"
                disabled={
                  dataRequestTransfer.type === null ||
                  dataRequestTransfer.type === "DIEU_CHUYEN_NOI_BO" ||
                  dataRequestTransfer.type === "DIEU_CHUYEN_NOI_BO_SERIAL" ||
                  dataRequestTransfer.type === "XUAT_CONG_CU_DUNG_CU"
                }
                withAsterisk
                nothingFoundMessage={"Không có dữ liệu"}
                data={
                  dataRequestTransfer.type !== "DIEU_CHUYEN_NOI_BO" &&
                  dataRequestTransfer.type !== "DIEU_CHUYEN_NOI_BO_SERIAL" &&
                  dataRequestTransfer.type !== "XUAT_CONG_CU_DUNG_CU"
                    ? dataBranch?.filter(
                        (item: any) =>
                          item.value !==
                          dataRequestTransfer.fromBranchId?.toString(),
                      )
                    : dataBranch
                }
                value={
                  dataRequestTransfer.toBranchId
                    ? dataRequestTransfer.toBranchId?.toString()
                    : null
                }
                comboboxProps={{ width: 225 }}
                {...form.getInputProps("toBranchId")}
                onChange={(value, option) => {
                  handleChangeValueInput(Number(value) || "", "toBranchId");
                  handleChangeValueInput("", "toInvId");
                  handleChangeValueInput(null, "toEmpId");
                  handleChangeValueInput(null, "attribute14");
                  handleChangeValueInput(null, "attribute15");
                  form.setValues((prev) => ({
                    ...prev,
                    toBranchId: Number(value),
                    toEmpId: null,
                    attribute14: null,
                    attribute15: null,
                  }));
                  if (
                    dataRequestTransfer.type === "DIEU_CHUYEN_NOI_BO" ||
                    dataRequestTransfer.type === "DIEU_CHUYEN_NOI_BO_SERIAL"
                  ) {
                    handleChangeValueInput(value || "", "fromBranchId");
                    form.setValues((prev) => ({
                      ...prev,
                      fromBranchId: Number(value),
                      toEmpId: null,
                    }));
                  }
                }}
              />
            </Table.Td>
          ) : (
            <></>
          )}
        </Table.Tr>
        <Table.Tr>
          <Table.Td>
            <Text fw={700} size="sm">
              ĐĐ làm việc
            </Text>
          </Table.Td>
          <Table.Td></Table.Td>
          <Table.Td>
            <Text size="xs">
              {detailFromBranch !== null ? detailFromBranch : ""}
            </Text>
          </Table.Td>
          {dataRequestTransfer.type !== "XUAT_TRA_NCC" ? (
            <Table.Td>
              <Text size="xs">
                {detailToBranch !== null ? detailToBranch : ""}
              </Text>
            </Table.Td>
          ) : (
            <></>
          )}
        </Table.Tr>
        <Table.Tr>
          <Table.Td>
            <Text fw={700} size="sm">
              Kho
            </Text>
          </Table.Td>
          <Table.Td></Table.Td>
          <Table.Td>
            <Select
              searchable
              clearable
              size="xs"
              placeholder="Chọn kho"
              nothingFoundMessage={"Không có dữ liệu"}
              disabled={!dataRequestTransfer.fromBranchId || listAdd.length > 0}
              data={
                dataRequestTransfer.type === "XUAT_CONG_CU_DUNG_CU"
                  ? dataInventory?.formInv
                      ?.filter(
                        (item: any) =>
                          item.value !==
                          dataRequestTransfer.toInvId?.toString(),
                      )
                      ?.map((item: any) => ({
                        label: item.label?.toString(),
                        value: item.value?.toString(),
                      }))
                  : (dataRequestTransfer.type === "DIEU_CHUYEN_CHI_NHANH" ||
                        dataRequestTransfer.type ===
                          "DIEU_CHUYEN_CHI_NHANH_SERIAL") &&
                      typeInv.length > 0
                    ? dataInventory?.formInv
                        ?.filter((item: any) => item.type === typeInv)
                        ?.map((item: any) => ({
                          label: item.label?.toString(),
                          value: item.value?.toString(),
                        }))
                    : dataInventory?.formInv?.map((item: any) => ({
                        label: item.label?.toString(),
                        value: item.value?.toString(),
                      }))
              }
              value={dataRequestTransfer.fromInvId?.toString() || null}
              comboboxProps={{ width: 200 }}
              {...form.getInputProps("fromInvId")}
              onChange={(value, option) => {
                handleChangeValueInput(Number(value) || "", "fromInvId");
                form.setValues((prev) => ({
                  ...prev,
                  fromInvId: Number(value),
                }));
              }}
            />
          </Table.Td>
          {dataRequestTransfer.type !== "XUAT_TRA_NCC" ? (
            <Table.Td>
              {dataRequestTransfer.type !== "XUAT_HUY" &&
              dataRequestTransfer.type !== "XUAT_DIEU_CHINH" ? (
                <Select
                  searchable
                  clearable
                  size="xs"
                  placeholder="Chọn kho"
                  withAsterisk
                  nothingFoundMessage={"Không có dữ liệu"}
                  disabled={
                    !dataRequestTransfer.toBranchId ||
                    dataRequestTransfer.type === "XUAT_CONG_CU_DUNG_CU"
                  }
                  data={
                    (dataRequestTransfer.type === "DIEU_CHUYEN_CHI_NHANH" ||
                      dataRequestTransfer.type ===
                        "DIEU_CHUYEN_CHI_NHANH_SERIAL") &&
                    typeInv.length > 0
                      ? dataInventory?.toInv
                          ?.filter((item: any) => item.type === typeInv)
                          ?.map((item: any) => ({
                            label: item.label?.toString(),
                            value: item.value?.toString(),
                          }))
                      : dataRequestTransfer.type === "XUAT_CONG_CU_DUNG_CU"
                        ? dataInventory?.toInv
                            ?.filter(
                              (item: any) =>
                                item.value !==
                                dataRequestTransfer.fromInvId?.toString(),
                            )
                            ?.map((item: any) => ({
                              label: item.label?.toString(),
                              value: item.value?.toString(),
                            }))
                        : dataInventory?.toInv?.map((item: any) => ({
                            label: item.label?.toString(),
                            value: item.value?.toString(),
                          }))
                  }
                  value={dataRequestTransfer.toInvId?.toString() || null}
                  comboboxProps={{ width: 200 }}
                  {...form.getInputProps("toInvId")}
                  onChange={(value, option) => {
                    handleChangeValueInput(Number(value) || "", "toInvId");
                    form.setValues((prev) => ({
                      ...prev,
                      toInvId: Number(value),
                    }));
                    if (dataSerial !== null) {
                      const updateListAdd = listAdd?.map((item) => ({
                        ...item,
                        toInvId: value ? Number(value) : 0,
                      }));
                      setListAdd(updateListAdd);
                    }
                  }}
                />
              ) : (
                <></>
              )}
            </Table.Td>
          ) : (
            <></>
          )}
        </Table.Tr>
        <Table.Tr>
          <Table.Td>
            <Text fw={700} size="sm">
              Họ và tên
            </Text>
          </Table.Td>
          <Table.Td>
            <Text size="xs">{dataRequestTransfer?.createByName}</Text>
          </Table.Td>
          <Table.Td></Table.Td>
          {dataRequestTransfer.type !== "XUAT_TRA_NCC" ? (
            <Table.Td>
              {dataRequestTransfer.type === "XUAT_HUY" ||
              dataRequestTransfer.type === "XUAT_DIEU_CHINH" ? (
                <Select
                  placeholder="Nhập tên nhân viên bên nhận"
                  data={dataEmpToBranch}
                  value={
                    form.getValues().toEmpId
                      ? form.getValues().toEmpId?.toString()
                      : null
                  }
                  size="xs"
                  searchable
                  clearable
                  disabled={
                    !dataRequestTransfer.toBranchId ||
                    dataRequestTransfer.toBranchId === 0
                  }
                  {...form.getInputProps("toEmpId")}
                  onChange={(e) => {
                    form.setValues((prev) => ({
                      ...prev,
                      toEmpId: e ? Number(e) : null,
                    }));
                    handleChangeValueInput(e ? Number(e) : null, "toEmpId");
                  }}
                  nothingFoundMessage={
                    dataRequestTransfer.toBranchId &&
                    dataRequestTransfer.toBranchId !== 0
                      ? "Không tìm thấy dữ liệu !"
                      : "Vui lòng chọn chi nhánh bên nhận trước !"
                  }
                />
              ) : (
                <></>
              )}
            </Table.Td>
          ) : (
            <></>
          )}
        </Table.Tr>
        <Table.Tr>
          <Table.Td>
            <Text fw={700} size="sm">
              Chức danh
            </Text>
          </Table.Td>
          <Table.Td>
            <Text size="xs">{dataRequestTransfer?.empRoleName}</Text>
          </Table.Td>
          <Table.Td></Table.Td>
          {dataRequestTransfer.type !== "XUAT_TRA_NCC" ? (
            <Table.Td>
              {dataRequestTransfer.type === "XUAT_HUY" || "XUAT_DIEU_CHINH" ? (
                <Text size="xs">
                  {getValueById(
                    dataRequestTransfer.toEmpId?.toString() ?? "",
                    dataDepAndRole,
                    "roleName",
                  )}
                </Text>
              ) : (
                <></>
              )}
            </Table.Td>
          ) : (
            <></>
          )}
        </Table.Tr>
        <Table.Tr>
          <Table.Td>
            <Text fw={700} size="sm">
              Bộ phận
            </Text>
          </Table.Td>
          <Table.Td>
            <Text size="xs">{dataRequestTransfer?.empDepartmentName}</Text>
          </Table.Td>
          <Table.Td></Table.Td>
          {dataRequestTransfer.type !== "XUAT_TRA_NCC" ? (
            <Table.Td>
              {dataRequestTransfer.type === "XUAT_HUY" || "XUAT_DIEU_CHINH" ? (
                <Text size="xs">
                  {getValueById(
                    dataRequestTransfer.toEmpId?.toString() ?? "",
                    dataDepAndRole,
                    "departmentName",
                  )}
                </Text>
              ) : (
                <></>
              )}
            </Table.Td>
          ) : (
            <></>
          )}
        </Table.Tr>
        {dataRequestTransfer.type === "DIEU_CHUYEN_CHI_NHANH" ||
        dataRequestTransfer.type === "DIEU_CHUYEN_CHI_NHANH_SERIAL" ||
        dataRequestTransfer.type === "XUAT_TRA_NCC" ? (
          <Table.Tr>
            <Table.Td>
              <Text fw={700} size="sm">
                Giao hàng
              </Text>
            </Table.Td>
            <Table.Td>
              <Select
                placeholder="Nhập phương thức giao hàng"
                size="xs"
                data={[
                  { label: "Không", value: "KHONG" },
                  { label: "Kỹ thuật", value: "KY_THUAT" },
                  { label: "Nội bộ", value: "NOI_BO" },
                  { label: "GHTK", value: "GHTK" },
                  { label: "Kho", value: "KHO" },
                ]}
                value={
                  dataRequestTransfer.attribute1
                    ? dataRequestTransfer.attribute1?.toString()
                    : "KHONG"
                }
                {...form.getInputProps("attribute1")}
                onChange={(e) => {
                  setDataRequestTransfer((prev) => ({
                    ...prev,
                    attribute1: e || null,
                    attribute14:
                      e === "GHTK" || e === "KHO" ? prev.attribute14 : null,
                    attribute15:
                      e === "GHTK" || e === "KHO" ? prev.attribute15 : null,
                  }));
                  form.setValues((prev) => ({
                    ...prev,
                    attribute1: e || null,
                    attribute14:
                      e === "GHTK" || e === "KHO" ? prev.attribute14 : null,
                    attribute15:
                      e === "GHTK" || e === "KHO" ? prev.attribute15 : null,
                  }));
                }}
                disabled={!dataRequestTransfer.type}
              />
            </Table.Td>
            <Table.Td></Table.Td>
            <Table.Td>
              {dataRequestTransfer.type !== null &&
                (dataRequestTransfer.attribute1 === "GHTK" ||
                  dataRequestTransfer.attribute1 === "KHO") && (
                  <Select
                    placeholder="Người nhận hàng"
                    data={dataEmployeeManagerItem
                      .filter((i) => i.mnv && i.hoVaTen)
                      .map((i) => ({
                        label: `${i.mnv} - ${i.hoVaTen}`,
                        value: `${i.mnv} - ${i.hoVaTen}`,
                      }))}
                    value={
                      dataRequestTransfer.attribute15 &&
                      String(dataRequestTransfer.attribute15).length > 0
                        ? String(dataRequestTransfer.attribute15)
                        : null
                    }
                    size="xs"
                    searchable
                    clearable
                    nothingFoundMessage="Không tìm thấy dữ liệu !"
                    {...form.getInputProps("attribute15")}
                    onChange={(e) => {
                      setDataRequestTransfer((prev) => ({
                        ...prev,
                        attribute15: e ? e : null,
                        attribute14: e
                          ? dataEmployeeManagerItem.find(
                              (i) => String(`${i.mnv} - ${i.hoVaTen}`) === e,
                            )?.soDienThoaiLienLac
                          : null,
                      }));

                      form.setValues((prev) => ({
                        ...prev,
                        attribute15: e ? e : null,
                        attribute14: e
                          ? dataEmployeeManagerItem.find(
                              (i) => String(`${i.mnv} - ${i.hoVaTen}`) === e,
                            )?.soDienThoaiLienLac
                          : null,
                      }));
                    }}
                  />
                )}
            </Table.Td>
          </Table.Tr>
        ) : (
          <></>
        )}
        {dataRequestTransfer.type !== null &&
        dataRequestTransfer.attribute1 === "GHTK" ? (
          <Table.Tr>
            <Table.Td>
              <Text fw={700} size="sm">
                Phí ship GHTK (ước tính)
              </Text>
            </Table.Td>
            <Table.Td>
              <Flex align="center" gap="xs">
                {isLoadingGhtkFee ? (
                  <Flex align="center" gap={6}>
                    <Loader size="xs" color="blue" />
                    <Text size="xs" c="dimmed">
                      Đang tính phí GHTK...
                    </Text>
                  </Flex>
                ) : ghtkEstimatedFee !== null ? (
                  <Badge color="teal" size="md" variant="filled">
                    <NumberFormatter
                      value={ghtkEstimatedFee}
                      thousandSeparator
                      suffix=" đ"
                    />
                  </Badge>
                ) : (
                  <Text size="xs" c="dimmed">
                    {!dataRequestTransfer.fromBranchId ||
                    !dataRequestTransfer.toBranchId
                      ? "Vui lòng chọn chi nhánh xuất và nhận"
                      : "Chưa tính được phí ship"}
                  </Text>
                )}
                <Tooltip label="Tính lại phí GHTK">
                  <ActionIcon
                    size="xs"
                    variant="subtle"
                    color="blue"
                    onClick={fetchGhtkEstimatedFee}
                    loading={isLoadingGhtkFee}
                  >
                    <IconRefresh size={14} />
                  </ActionIcon>
                </Tooltip>
              </Flex>
            </Table.Td>
            <Table.Td></Table.Td>
            <Table.Td></Table.Td>
          </Table.Tr>
        ) : null}
        <Table.Tr>
          <Table.Td>
            <Text fw={700} size="sm">
              Lý do YCDC
            </Text>
          </Table.Td>
          <Table.Td colSpan={3} w={"100%"}>
            <Select
              placeholder="Lý do YCDC"
              size="xs"
              data={dataReasonRequestTransfer}
              value={dataRequestTransfer?.attribute9 || null}
              searchable
              clearable
              nothingFoundMessage="Không tìm thấy dữ liệu !"
              onChange={(e) => handleChangeValueInput(e ? e : "", "attribute9")}
            />
          </Table.Td>
        </Table.Tr>
        <Table.Tr>
          <Table.Td>
            <Text fw={700} size="sm">
              Ghi chú
            </Text>
          </Table.Td>
          <Table.Td colSpan={3}>
            <Textarea
              placeholder="Vui lòng nhập"
              size="xs"
              rows={
                dataRequestTransfer.type === "DIEU_CHUYEN_NOI_BO" ||
                dataRequestTransfer.type === "XUAT_CONG_CU_DUNG_CU"
                  ? 4
                  : 6
              }
              value={dataRequestTransfer.note}
              {...form.getInputProps("note")}
              onChange={(e) => {
                handleChangeValueInput(e.currentTarget.value, "note");
                form.setValues((prev) => ({
                  ...prev,
                  note: e.currentTarget.value,
                }));
              }}
            />
          </Table.Td>
          {/* {dataRequestTransfer.type !== "XUAT_HUY" ? (
            <Table.Td></Table.Td>
          ) : (
            <></>
          )} */}
        </Table.Tr>
      </>
    );

    return (
      <Box
        component="form"
        onSubmit={form.onSubmit(() => {
          handleCreateRequestTransfer(true);
        })}
      >
        <Group m={"16px 16px 0px 16px"} justify="start">
          <Text c={"red"} fw={700}>
            Loại phiếu
          </Text>
          <Select
            size="xs"
            placeholder="Chọn loại phiếu"
            // data={dataTblInventoryTransactionType}
            data={dataTypeSelect
              ?.filter(
                (item: any) =>
                  Number(item.type) === Number(typeRequestTransfer),
              )
              ?.map((item: any) => ({
                label: String(item.label),
                value: String(item.value),
              }))}
            value={
              dataRequestTransfer.type
                ? dataRequestTransfer.type?.toString()
                : null
            }
            onChange={(value) => {
              handleChangeValueInput(value || null, "type");
              fetchDataCreateRequestTransfer(value ?? null);
            }}
            w={200}
          />
        </Group>
        <Flex gap={"xs"}>
          <Table
            striped
            horizontalSpacing="sm"
            withColumnBorders
            withTableBorder
            mt={5}
          >
            <Table.Thead>{tbHeader}</Table.Thead>
            <Table.Tbody>{tbBody}</Table.Tbody>
          </Table>
        </Flex>
      </Box>
    );
  };

  const titleSell = () => {
    return (
      <Box
        component="form"
        onSubmit={form.onSubmit(() => {
          if (finish) {
            setTimeout(() => {
              handleCreateRequestTransfer(true);
            }, 100);
          } else {
            setTimeout(() => {
              handleCreateRequestTransfer(false);
            }, 100);
          }
        })}
      >
        <Group mt={-10} align="center" justify="space-between">
          <Flex
            gap="md"
            justify="flex-start"
            align="center"
            direction="row"
            wrap="wrap"
            mb={"xs"}
          >
            <RequestTransferStatus
              status={dataRequestTransfer.statusCode?.toString() || ""}
            />
          </Flex>
          <Flex gap={10} align="center" justify={"flex-end"}>
            <Button
              my={"10px"}
              leftSection={<IconArrowLeft size={14} />}
              color="red"
              size="xs"
              onClick={() => handleReturnRequestTransfer()}
            >
              Quay lại
            </Button>
            {["DIEU_CHUYEN_NOI_BO", "DIEU_CHUYEN_CHI_NHANH"].includes(
              dataRequestTransfer?.type || "",
            ) && (
              <Flex gap={5}>
                <DemoExportRequestTransfer />
                <Button
                  size="xs"
                  leftSection={<IconArrowBigUp size={14} />}
                  fw={600}
                  disabled={!dataRequestTransfer?.fromInvId}
                  onClick={() => handleFileUpload()}
                >
                  Import Excel
                  {/* <FileButton
                  onChange={(file) => file && handleFileUpload(file)}
                  accept=".xlsx, .xls"
                >
                  {(props) => (
                    <div
                      {...props}
                      style={{
                        cursor: "pointer",
                        display: "inline-block",
                        width: "100%",
                      }}
                    >
                      Import Excel
                    </div>
                  )}
                </FileButton> */}
                </Button>
              </Flex>
            )}
            {/* <Button
              my={"10px"}
              leftSection={<IconFileSpreadsheet size={14} />}
              color="#11733E"
              size="xs"
              onClick={() => handleOpenFileDrop()}
              disabled={
                dataRequestTransfer.type === null ||
                dataRequestTransfer.fromInvId === null ||
                dataRequestTransfer.fromInvId === 0 ||
                dataRequestTransfer.fromInvId?.toString() === ""
              }
            >
              Import Excel (Crtl + I)
            </Button> */}
            <Button
              my={"10px"}
              leftSection={<IconPlus size={14} />}
              disabled={disabledButton || dataRequestTransfer.type === null}
              color="blue"
              size="xs"
              onClick={() => setFinish(false)}
              type="submit"
            >
              Lưu (Crtl + S)
            </Button>
            <Button
              my={"10px"}
              leftSection={<IconCheck size={14} />}
              disabled={disabledButton || dataRequestTransfer.type === null}
              color="green"
              size="xs"
              type="submit"
              onClick={() => setFinish(true)}
            >
              Hoàn thành (Crtl + Q)
            </Button>
          </Flex>
        </Group>
      </Box>
    );
  };

  //table state
  const [valueDebounced, setValueDebounced] = useDebouncedState("", 500);

  const fetchItemSell = async () => {
    const keySearch = valueDebounced.toLowerCase();
    const url = `/api/v1/RequestInventoryTransaction/search-item-transaction-request?Key=${keySearch}&Page=30&InvId=${dataRequestTransfer?.fromInvId}&Type=${dataRequestTransfer?.type}`;
    try {
      if (dataRequestTransfer.fromInvId) {
        const searchResult =
          await repositoryPos.get<MessageResponse<itemSearchTrasferModel[]>>(
            url,
          );
        if (searchResult?.data) {
          setDataProducts(searchResult.data);
          // table.setCreatingRow(null);
        } else {
          setDataProducts([]);
        }
      } else {
        setDataProducts([]);
        table.setCreatingRow(null);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setDataProducts([]);
    }
  };

  const fetchDataCreateRequestTransfer = async (type: string | null) => {
    if (type && type !== null) {
      let url = "";

      if (
        type === "DIEU_CHUYEN_CHI_NHANH" ||
        type === "DIEU_CHUYEN_CHI_NHANH_SERIAL"
      ) {
        url += `create-request-transfer?prefix=DC`;
      }

      if (type === "XUAT_HUY") {
        url += `create-request-cancellation?prefix=XH`;
      }

      if (
        type === "DIEU_CHUYEN_NOI_BO" ||
        type === "DIEU_CHUYEN_NOI_BO_SERIAL"
      ) {
        url += `create-request-internal-transfer?prefix=XN`;
      }

      if (type === "XUAT_CONG_CU_DUNG_CU") {
        url += `create-request-internal-transfer?prefix=XC`;
      }

      if (type === "XUAT_DIEU_CHINH") {
        url += `create-request-adjustment?prefix=XD`;
      }

      if (type === "XUAT_TRA_NCC") {
        url += `create-request-return-vendor?prefix=XT`;
      }

      const response = await repositoryMdm.get<MessageResponse<any>>(
        `/api/v1/TblRequestTransfer/${url}`,
      );

      if (response?.success && response.data) {
        const result = response.data;
        setDataRequestTransfer({
          ...result,
          attribute1: "KHONG",
          attribute3:
            dataRequestTransfer.type === "DIEU_CHUYEN_NOI_BO" ||
            dataRequestTransfer.type === "DIEU_CHUYEN_CHI_NHANH" ||
            dataRequestTransfer.type === "XUAT_CONG_CU_DUNG_CU"
              ? "TAT_CA"
              : null,
          attribute12:
            dataSerial?.typeView !== undefined ? dataSerial?.typeView : null,
          type: type,
          empRoleId: JSON.parse(localStorage.getItem("userLogin") ?? "")
            ?.roleId,
          empDepartmentId: JSON.parse(localStorage.getItem("userLogin") ?? "")
            ?.departmentId,
          toBranchId:
            dataSerial?.listSerialProps !== undefined
              ? dataSerial?.listSerialProps[0]?.invOrgId
              : null,
          createBy:
            JSON.parse(localStorage.getItem("userLogin") || "{}")?.id || "",
          createDate: dataSerial?.createDate
            ? dataSerial?.createDate
            : dataCreateDate,
          empBranchId:
            JSON.parse(localStorage.getItem("userLogin") || "{}")?.branchId ||
            "",
          fromBranchId:
            dataSerial?.listSerialProps !== undefined
              ? dataSerial?.listSerialProps[0]?.invOrgId
              : null,
          fromInvId:
            dataSerial?.listSerialProps !== undefined
              ? dataSerial?.listSerialProps[0]?.subInvId
              : null,
        });
        form.setValues((prev) => ({
          ...prev,
          type: type,
          attribute1: "KHONG",
          fromBranchId:
            dataSerial?.listSerialProps !== undefined
              ? dataSerial?.listSerialProps[0]?.invOrgId
              : null,
          fromInvId:
            dataSerial?.listSerialProps !== undefined
              ? dataSerial?.listSerialProps[0]?.subInvId
              : null,
          toBranchId:
            dataSerial?.listSerialProps !== undefined
              ? dataSerial?.listSerialProps[0]?.invOrgId
              : null,
          createBy:
            JSON.parse(localStorage.getItem("userLogin") || "{}")?.id || "",
        }));
        if (dataSerial?.listSerialProps?.length > 0) {
          const dataProduct = dataSerial?.listSerialProps?.map((item: any) => ({
            actualQuantity: 0,
            fromBranchId: item?.invOrgId,
            fromInvId: item?.subInvId,
            fromSubInvOrgName: item?.subInvName,
            id: 0,
            itemCode: item?.itemCode,
            itemId: item?.itemId,
            itemName: item?.itemName,
            poPrice: 0,
            primaryQuantity: item?.quantity,
            primaryUom: item?.subUomCode,
            requestBy: 0,
            requestByName: "",
            requestId: 0,
            serial: item?.newSerial === null ? item?.serial : item?.newSerial,
            status: "",
            toBranchId: item?.invOrgId,
            toInvId: 0,
            virtualQuantity: 0,
          }));
          setListAdd(dataProduct);
        } else {
          setListAdd([]);
        }
        setSelectedProducts(new Set());
      }
    } else {
      return;
    }
  };

  //#region import excel
  const handleFileUpload = () => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = ".xlsx, .xls";
    input.onchange = () => {
      const file = input.files?.[0];
      if (!file) {
        NotificationExtension.Warn("Không có tập tin nào được chọn");
        return;
      }
      const reader = new FileReader();
      reader.onload = (event) => {
        try {
          const binaryStr = event.target?.result;
          const loadedWorkbook = xlsx.read(binaryStr, { type: "binary" });
          const sheetNames = loadedWorkbook.SheetNames;

          setWorkbook(loadedWorkbook);
          setSheetNames(sheetNames);
          setOpenModal(true);
        } catch (err) {
          console.error(err);
          NotificationExtension.Warn("Error processing the file");
        }
      };
      reader.readAsBinaryString(file);
    };
    input.click(); //j hàm mở chọn tệp
  };

  const handleSheetSelection = async () => {
    if (!selectedSheets || selectedSheets.length === 0) {
      NotificationExtension.Warn("Không có sheets để chọn");
      return;
    }

    if (!workbook) {
      NotificationExtension.Warn("No workbook loaded");
      return;
    }

    // Lấy dữ liệu từ các sheet được chọn
    const listItems = selectedSheets.flatMap((sheetName) => {
      const sheet = workbook.Sheets[sheetName];
      const jsonData: { "Mã sản phẩm": string; "Số lượng": string }[] =
        xlsx.utils.sheet_to_json(sheet);

      return jsonData
        .filter((row) => row["Mã sản phẩm"] && row["Số lượng"]) // Lọc ra các dòng hợp lệ
        .map((row) => ({
          itemCode: row["Mã sản phẩm"].trim(), // Chuẩn hóa dữ liệu
          quantity: Number(row["Số lượng"]),
        }));
    });

    try {
      const body = {
        key: "",
        page: 0,
        invId: dataRequestTransfer?.fromInvId,
        type: dataRequestTransfer?.type,
        items: listItems,
      };
      const url = `/api/v1/RequestInventoryTransaction/search-item-transaction-request`;

      const response = await repositoryPos.post<
        MessageResponse<dataOrderDetailTable[]>
      >(url, body);

      if (response && response.success) {
        const responseData = response.data;
        if (Array.isArray(responseData)) {
          const checkData = [
            ...listAdd,
            ...responseData.map((item: dataOrderDetailTable) => ({
              ...item,
              fromInvId: dataRequestTransfer?.fromInvId,
            })),
          ];

          setListAdd(checkData);
          NotificationExtension.Success("Import Excel thành công");
        }
      } else {
        NotificationExtension.Fails(response?.message || "");
      }

      if (response?.data?.length === 0) {
        NotificationExtension.Warn("Không có sản phẩm trong kho");
      }
    } catch (error) {
      setIsError(true);
      console.error(error);
    }

    setOpenModal(false);
  };

  const getDataVendor = async () => {
    const res = await repositoryMdm.get<MessageResponse<any>>(
      `/api/v1/TblVendor/get-all`,
    );

    if (res && res?.success) {
      const dataApi = res.data;
      const uniqueVendorCodes = new Set();
      const filteredData = dataApi
        .filter(
          (item: any) => item.vendorName != null && item.vendorCode != null,
        )
        .filter((item: any) => {
          const vendorCode = item.vendorCode?.split(" - ")[0];
          if (uniqueVendorCodes.has(vendorCode)) {
            return false;
          } else {
            uniqueVendorCodes.add(vendorCode);
            return true;
          }
        })
        .map((item: any) => ({
          value: item.vendorCode?.split(" - ")[0],
          label: item.vendorName ?? "",
        }));
      const filteredDataId = dataApi
        .filter((item: any) => item.id != null && item.vendorCode != null)
        .map((item: any) => ({
          value: item.vendorCode?.split(" - ")[0],
          label: item.id?.toString() ?? "",
        }));

      setDataVendorSelect(filteredData);
      setDataVendorId(filteredDataId);
    }
  };

  const getDataEmpToBranch = async () => {
    const res = await repositoryPos.get<MessageResponse<any>>(
      `/api/v1/TblDmEmployee/get-list?BranchId=${dataRequestTransfer.toBranchId}&Take=200`,
    );

    if (res && res?.success) {
      const dataApi = res.data;
      setDataEmpToBranch(
        dataApi
          .filter((item: any) => item.fullname != null && item.id != null)
          .map((item: any) => ({
            value: item.id?.toString(),
            label: item.fullname ?? "",
          })),
      );
      setDataDepAndRole(
        dataApi.map((item: any) => ({
          id: item.id?.toString(),
          departmentId: item.departmentId,
          departmentName: item.departmentName,
          roleId: item.roleId,
          roleName: item.roleName,
        })),
      );
    }
  };

  const fetchDataBranch = async () => {
    const getDataBranch = await getBranchSelect();

    const mappedData = getDataBranch
      .filter(
        (item) =>
          item.value != null && item.value !== "-1" && item.text != null,
      )
      .map((item) => ({
        value: item.value,
        label: `${item.att2} - ${item.text}`,
      }));
    setDataBranch(mappedData);
  };

  const getDetailBranch = async (idBranch: number, typeBranch: string) => {
    const res = await repositoryPos.get<MessageResponse<any>>(
      `/api/v1/TblDmInventory/get-detail-branch?id=${idBranch}`,
    );

    if (res && res?.success) {
      const result = res.data;
      if (typeBranch === "Bên xuất") {
        setDetailFromBranch(result?.attribute5);
      } else {
        setDetailToBranch(result?.attribute5);
      }
    }
  };

  const fetchdataInventory = async (idInvOrg: string | number) => {
    const url = `/api/v1/TblDmInventory/get-select-by-branch?branchId=${idInvOrg}`;
    try {
      const getDataInventory =
        await repositoryPos.get<MessageResponse<any>>(url);
      if (getDataInventory?.data) {
        const filteredData = getDataInventory?.data;
        const mappedData = filteredData?.map((item: any) => ({
          value: item.inventoryId.toString(),
          label: `(${item.inventoryCode}) ${item.inventoryName}`,
          type: item.attribute3?.toString(),
        }));
        return mappedData;
      } else {
        return [];
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      return [];
    }
  };

  const getDataReasonRequestTransfer = async () => {
    const res = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblTransferReason/get-list?Skip=0&Take=100",
    );

    if (res && res.success) {
      let data = [];

      if (Number(typeRequestTransfer) === 1) {
        data = res.data
          .filter((i: any) => i.type === "CN" && i.name && i.code)
          .map((i: any) => ({
            label: String(i.name),
            value: String(i.code),
          }));
      } else if (Number(typeRequestTransfer) === 2) {
        data = res.data
          .filter((i: any) => i.type === "NB" && i.name && i.code)
          .map((i: any) => ({
            label: String(i.name),
            value: String(i.code),
          }));
      }

      setDataReasonRequestTransfer(data);
    }
  };

  const getDataEmpManagerItem = async () => {
    const res = await repositoryMdm.get<MessageResponse<any>>(
      `/api/v1/TblItemManager/get-list?Skip=0&Take=300&IdChiNhanh=${dataRequestTransfer.toBranchId}`,
    );

    if (res && res.success) {
      const data = res.data;

      setDataEmployeeManagerItem(data);
    }
  };

  const handleCreateRequestTransfer = async (isFinish: boolean) => {
    let notifiValidate = "";

    const istoInvIdMissing = !dataRequestTransfer.toBranchId;
    const isfromInvIdMissing = !dataRequestTransfer.fromBranchId;
    const isProductListEmpty = listAdd.length < 1;

    if (isfromInvIdMissing) {
      notifiValidate = "Bạn chưa chọn kho bên xuất";
    } else if (
      istoInvIdMissing &&
      dataRequestTransfer.type !== "XUAT_HUY" &&
      dataRequestTransfer.type !== "XUAT_DIEU_CHINH" &&
      dataRequestTransfer.type !== "XUAT_TRA_NCC"
    ) {
      notifiValidate = "Bạn chưa chọn kho bên nhận";
    } else if (isProductListEmpty) {
      notifiValidate = "Bạn chưa chọn sản phẩm nào";
    } else if (dataRequestTransfer.type === null) {
      notifiValidate = "Bạn chưa chọn loại phiếu";
    }

    if (
      !dataRequestTransfer.attribute9 ||
      String(dataRequestTransfer.attribute9).length === 0
    ) {
      notifiValidate = "Vui lòng chọn lý do YCDC !";
    }

    if (
      (dataRequestTransfer.attribute1 === "GHTK" ||
        dataRequestTransfer.attribute1 === "KHO") &&
      !dataRequestTransfer.attribute15
    ) {
      NotificationExtension.Fails("Vui lòng chọn người nhận hàng cho GHTK !");
      return;
    }

    if (
      (dataRequestTransfer.attribute1 === "GHTK" ||
        dataRequestTransfer.attribute1 === "KHO") &&
      !dataRequestTransfer.attribute14
    ) {
      NotificationExtension.Fails(
        "Không tìm thấy số điện thoại của người nhận, vui lòng kiểm tra ở phần thiết lập !",
      );
      return;
    }

    if (notifiValidate) {
      NotificationExtension.Fails(notifiValidate);
      return;
    }

    try {
      let url = "";
      if (
        dataRequestTransfer.type === "DIEU_CHUYEN_CHI_NHANH" ||
        dataRequestTransfer.type === "DIEU_CHUYEN_CHI_NHANH_SERIAL"
      ) {
        url = `create-request-transfer?IsFinish=${isFinish}`;
      }
      if (dataRequestTransfer.type === "XUAT_HUY") {
        url = `create-request-cancellation?IsFinish=${isFinish}`;
      }
      if (
        dataRequestTransfer.type === "DIEU_CHUYEN_NOI_BO" ||
        dataRequestTransfer.type === "DIEU_CHUYEN_NOI_BO_SERIAL"
      ) {
        url = `create-request-internal-transfer?IsFinish=${isFinish}`;
      }
      if (dataRequestTransfer.type === "XUAT_CONG_CU_DUNG_CU") {
        url = `create-request-internal-transfer?IsFinish=${isFinish}`;
      }
      if (dataRequestTransfer.type === "XUAT_DIEU_CHINH") {
        url = `create-request-adjustment?IsFinish=${isFinish}`;
      }
      if (dataRequestTransfer.type === "XUAT_TRA_NCC") {
        url = `create-request-return-vendor?IsFinish=${isFinish}`;
      }
      const dataCreate = {
        ...dataRequestTransfer,
        statusCode: "PHIEU_TAO_MOI",
        tblDmRequestTransferDetailCommands: listAdd || [],
      };

      if ((listAdd?.length || 0) > 5000) {
        NotificationExtension.Warn("Số dòng sản phẩm vượt quá 5000 dòng");
        return;
      }

      const response = await repositoryMdm.post<MessageResponse<any>>(
        `/api/v1/TblRequestTransfer/${url}`,
        dataCreate,
      );

      if (response && response?.success) {
        setDisabledButton(true);
        NotificationExtension.Success("Tạo mới phiếu chuyển kho thành công");
        setTimeout(() => {
          navigate(-1);
        }, 1000);
      }
    } catch (error) {}
  };

  const handleChangeValueInput = (
    value: string | boolean | null | number,
    key: string,
  ) => {
    setDataRequestTransfer((prevData) => ({ ...prevData, [key]: value }));
  };

  const handleSelectProduct = async (product: any, rowIndex: number) => {
    const addData: dataOrderDetailTable = {
      id: 0,
      itemName: product.itemName || "",
      fromBranchId: dataRequestTransfer.fromBranchId || 0,
      fromInvId: dataRequestTransfer.fromInvId || 0,
      fromSubInvOrgName: product.invName || "",
      itemId: product.itemId,
      itemCode: product.itemCode || "",
      requestId: 0,
      requestBy: selectedCustomer.requestBy || 0,
      toBranchId: dataRequestTransfer.toBranchId || 0,
      toInvId: dataRequestTransfer.toInvId || 0,
      primaryQuantity: 1,
      primaryUom: product.primaryUomCode || "",
      requestByName: selectedCustomer.requestByName || "",
      virtualQuantity: product.virtualQuantity || 0,
      actualQuantity: product.actualQuantity || 0,
      poPrice: product?.poPrice || 0,
      serial: product?.serial || "",
      status:
        dataRequestTransfer.type === "XUAT_HUY" ? product.status || "" : "",
    };

    const handleApiCallAndUpdate = async () => {
      setListAdd((prevList) => {
        const updatedList = [...prevList];

        const isProductExist = updatedList.some(
          (item, index) => index === rowIndex,
        );
        if (
          dataRequestTransfer.type === "DIEU_CHUYEN_CHI_NHANH" ||
          dataRequestTransfer.type === "DIEU_CHUYEN_NOI_BO" ||
          dataRequestTransfer.type === "XUAT_CONG_CU_DUNG_CU"
        ) {
          setSelectedProducts((prevSelectedProducts) => {
            const newSelectedProducts = new Set(prevSelectedProducts);
            newSelectedProducts.delete(prevList[rowIndex]?.itemId);
            newSelectedProducts.add(product.itemId);
            return newSelectedProducts;
          });
        } else {
          setSelectedProducts((prevSelectedProducts) => {
            const newSelectedProducts = new Set(prevSelectedProducts);
            newSelectedProducts.delete(prevList[rowIndex]?.serial);
            newSelectedProducts.add(product.serial);
            return newSelectedProducts;
          });
        }

        if (isProductExist) {
          updatedList[rowIndex] = addData;
        } else {
          updatedList.unshift(addData);
        }

        return updatedList;
      });
    };

    if (listAdd.length > 0) {
      // if (selectedCustomer.requestBy) {
      await handleApiCallAndUpdate();
      // } else {
      //   NotificationExtension.Warn("Bạn chưa chọn nhân viên yêu cầu");
      // }
    } else {
      await handleApiCallAndUpdate();
    }

    table.setEditingRow(null);
    table.setEditingCell(null);
  };

  const handleReturnRequestTransfer = () => {
    navigate(-1);
  };

  const TableSelect: React.FC<TableSelectProps> = ({
    dataProducts,
    onSelectProduct,
    rowIndex,
  }: any) => {
    return (
      <Table.ScrollContainer mah={450} minWidth={300} type="native">
        <Table striped withTableBorder>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>Chọn</Table.Th>
              <Table.Th>ID</Table.Th>
              <Table.Th>Mã sản phẩm</Table.Th>
              <Table.Th>Tên sản phẩm</Table.Th>
              <Table.Th>Đơn vị</Table.Th>
              {dataRequestTransfer.type === "XUAT_HUY" ||
              dataRequestTransfer.type === "DIEU_CHUYEN_NOI_BO_SERIAL" ||
              dataRequestTransfer.type === "DIEU_CHUYEN_CHI_NHANH_SERIAL" ||
              dataRequestTransfer.type === "XUAT_DIEU_CHINH" ||
              dataRequestTransfer.type === "XUAT_TRA_NCC" ? (
                <>
                  <Table.Th>Serial</Table.Th>
                  <Table.Th>Trạng thái</Table.Th>
                </>
              ) : (
                <>
                  <Table.Th>Tồn kho</Table.Th>
                  <Table.Th>Sẵn hàng</Table.Th>
                </>
              )}
              <Table.Th>Chi nhánh</Table.Th>
              {/* <Table.Th>Mã kho</Table.Th> */}
              <Table.Th>Kho</Table.Th>
            </Table.Tr>
          </Table.Thead>
          {dataProducts?.length > 0 ? (
            <Table.Tbody>
              {dataProducts?.map((product: any, index: any) => (
                <Table.Tr key={product.itemId + index}>
                  <Table.Td>
                    <Button
                      size="xs"
                      variant="filled"
                      onClick={(e) => {
                        onSelectProduct(product, rowIndex);
                        // table.setCreatingRow(null);
                      }}
                      disabled={
                        dataRequestTransfer.type === "DIEU_CHUYEN_CHI_NHANH" ||
                        dataRequestTransfer.type === "DIEU_CHUYEN_NOI_BO" ||
                        dataRequestTransfer.type === "XUAT_CONG_CU_DUNG_CU"
                          ? selectedProducts.has(product.itemId) ||
                            Number(product.actualQuantity) -
                              Number(product.virtualQuantity) ===
                              0
                          : selectedProducts.has(product.serial)
                      }
                    >
                      {dataRequestTransfer.type === "DIEU_CHUYEN_CHI_NHANH" ||
                      dataRequestTransfer.type === "DIEU_CHUYEN_NOI_BO" ||
                      dataRequestTransfer.type === "XUAT_CONG_CU_DUNG_CU"
                        ? selectedProducts.has(product.itemId)
                          ? "Đã chọn"
                          : "Chọn"
                        : selectedProducts.has(product.serial)
                          ? "Đã chọn"
                          : "Chọn"}
                    </Button>
                  </Table.Td>
                  <Table.Td>{product.itemId}</Table.Td>
                  <Table.Td>{product.itemCode}</Table.Td>
                  <Table.Td>{product.itemName}</Table.Td>
                  <Table.Td>{product.primaryUomCode}</Table.Td>
                  {dataRequestTransfer.type === "XUAT_HUY" ||
                  dataRequestTransfer.type === "DIEU_CHUYEN_NOI_BO_SERIAL" ||
                  dataRequestTransfer.type === "DIEU_CHUYEN_CHI_NHANH_SERIAL" ||
                  dataRequestTransfer.type === "XUAT_DIEU_CHINH" ||
                  dataRequestTransfer.type === "XUAT_TRA_NCC" ? (
                    <>
                      <Table.Td>{product.serial}</Table.Td>
                      <Table.Td>{product.status}</Table.Td>
                    </>
                  ) : (
                    <>
                      <Table.Td>{product.actualQuantity}</Table.Td>
                      <Table.Td>
                        {Number(product.actualQuantity) -
                          Number(product.virtualQuantity)}
                      </Table.Td>
                    </>
                  )}
                  <Table.Td>{product.invName}</Table.Td>
                  <Table.Td>
                    ({product.invCode}) - {product.invName}
                  </Table.Td>
                  {/* <Table.Td>{product.oldvirua}</Table.Td>
                <Table.Td>{product.oldton}</Table.Td> */}
                </Table.Tr>
              ))}
            </Table.Tbody>
          ) : (
            <Box
              style={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
              }}
            >
              <Text>
                {dataRequestTransfer.type === "DIEU_CHUYEN_CHI_NHANH" ||
                dataRequestTransfer.type === "DIEU_CHUYEN_NOI_BO" ||
                dataRequestTransfer.type === "XUAT_CONG_CU_DUNG_CU"
                  ? "Hãy nhập mã sản phẩm !"
                  : "Hãy nhập Serial sản phẩm !"}
              </Text>
            </Box>
          )}
        </Table>
      </Table.ScrollContainer>
    );
  };

  const columns = React.useMemo<MRT_ColumnDef<dataOrderDetailTable>[]>(
    () => [
      {
        header: "STT",
        size: 30,
        enableEditing: false,
        Cell: ({ row }) => {
          return <>{row.index + 1}</>;
        },
      },
      {
        accessorKey: "serial",
        header: "Serial",
        enableEditing: false,
        size: 100,
      },
      {
        accessorKey: "itemCode",
        header: "Mã sản phẩm",
        enableEditing: true,
        size: 100,
        Edit: ({ cell, row, table, column }) => {
          const [keepRef, setKeepRef] = useState(false);
          const ref = useClickOutside(() => {
            if (!keepRef) {
              table.setEditingCell(null);
            }
          });

          return (
            <div ref={ref}>
              <Menu
                opened={opened}
                onChange={setOpened}
                shadow="md"
                width={"800"}
                position="bottom-start"
              >
                <Menu.Target>
                  <TextInput
                    autoFocus
                    onChange={async (e) => {
                      const _key = e.target.value ?? "";
                      setValueDebounced(_key);
                    }}
                    onFocus={() => setKeepRef(true)}
                    onBlur={() => setKeepRef(false)}
                    onKeyDown={getHotkeyHandler([
                      [
                        "Enter",
                        () => {
                          if (
                            dataRequestTransfer?.type !==
                              "DIEU_CHUYEN_CHI_NHANH" &&
                            dataRequestTransfer?.type !==
                              "DIEU_CHUYEN_NOI_BO" &&
                            dataRequestTransfer?.type !== "XUAT_CONG_CU_DUNG_CU"
                          ) {
                            if (
                              dataProducts.length > 1 ||
                              selectedProducts.has(dataProducts[0].serial)
                            ) {
                              return;
                            } else {
                              handleSelectProduct(dataProducts[0], row.index);
                              setValueDebounced("");
                              table.setCreatingRow(null);
                            }
                          } else {
                            if (
                              dataProducts.length > 1 ||
                              selectedProducts.has(dataProducts[0].itemId)
                            ) {
                              return;
                            } else {
                              handleSelectProduct(dataProducts[0], row.index);
                              setValueDebounced("");
                              table.setCreatingRow(null);
                            }
                          }
                        },
                      ],
                    ])}
                  />
                </Menu.Target>
                <Menu.Dropdown w={1010}>
                  <TableSelect
                    dataProducts={dataProducts}
                    onSelectProduct={(product) =>
                      handleSelectProduct(product, row.index)
                    }
                    rowIndex={row.index}
                  />
                </Menu.Dropdown>
              </Menu>
            </div>
          );
        },
      },
      {
        accessorKey: "itemName",
        header: "Tên sản phẩm",
        enableEditing: false,
        Cell: ({ renderedCellValue }) => {
          return renderedCellValue ? (
            <Tooltip label={renderedCellValue}>
              <Text size="11px" truncate="end" h={12} w={280}>
                {renderedCellValue}
              </Text>
            </Tooltip>
          ) : (
            <></>
          );
        },
      },
      {
        accessorKey: "primaryUom",
        header: "ĐVT1",
        size: 100,
        enableEditing: false,
      },
      {
        accessorKey: "primaryQuantity",
        header: "SL1",
        enableEditing:
          dataRequestTransfer.type !== "DIEU_CHUYEN_CHI_NHANH_SERIAL" &&
          dataRequestTransfer.type !== "DIEU_CHUYEN_NOI_BO_SERIAL" &&
          dataRequestTransfer.type !== "XUAT_HUY" &&
          dataRequestTransfer.type !== "XUAT_DIEU_CHINH" &&
          dataRequestTransfer.type !== "XUAT_TRA_NCC",
        size: 100,
        Edit: ({ row, column, table }) => {
          return (
            <NumberInput
              // autoFocus
              placeholder="Nhập số lượng"
              // max={row.original.virtualQuantity}
              hideControls
              value={row._valuesCache[column.id]}
              onChange={(e) => {
                setListAdd((prevData: any) => {
                  return prevData.map((item: any, i: any) =>
                    i === row.index
                      ? {
                          ...item,
                          primaryQuantity:
                            e === undefined || e === null || e === ""
                              ? null
                              : Number(e) <=
                                  Number(
                                    item.actualQuantity - item.virtualQuantity,
                                  )
                                ? Number(e)
                                : (NotificationExtension.Fails(
                                    "Số lượng sản phẩm yêu cầu vượt quá số lượng sẵn hàng !",
                                  ),
                                  1),
                        }
                      : item,
                  );
                });
              }}
              onBlur={() => {
                table.setEditingCell(null);
                if (
                  Number(row.original.primaryQuantity) < 1 ||
                  Number(row.original.primaryQuantity) === null
                ) {
                  setListAdd((prevData: any) => {
                    return prevData.map((item: any, i: any) =>
                      i === row.index
                        ? {
                            ...item,
                            primaryQuantity: 1,
                          }
                        : item,
                    );
                  });
                } else {
                  setDisabledButton(false);
                }
              }}
            />
          );
        },
      },
      {
        accessorKey: "subUom",
        header: "ĐVT2",
        size: 100,
        enableEditing: false,
      },
      {
        accessorKey: "subQuantity",
        header: "SL2",
        enableEditing: false,
        size: 100,
        Edit: ({ row, column, table }) => {
          return (
            <NumberInput
              // autoFocus
              placeholder="Nhập số lượng"
              hideControls
              // max={row.original.tonao}
              value={row._valuesCache[column.id]}
              onChange={(e) => {
                setListAdd((prevData: any) => {
                  return prevData.map((item: any, i: any) =>
                    i === row.index
                      ? {
                          ...item,
                          subQuantity: e ? Number(e) : null,
                        }
                      : item,
                  );
                });
              }}
              onBlur={(e) => {
                table.setEditingCell(null);
              }}
            />
          );
        },
      },
      {
        accessorKey: "poPrice",
        header: "Thành tiền",
        size: 200,
        enableEditing: false,
      },
      {
        accessorKey: "status",
        header: "Tình trạng",
        size: 200,
        enableEditing: false,
        // Edit: ({ row, column, table }) => {
        //   return (
        //     <Select
        //       // autoFocus
        //       placeholder="Chọn tình trạng"
        //       data={dataSerialStatus}
        //       value={row._valuesCache[column.id]?.toString() || ""}
        //       onChange={(e) => {
        //         setListAdd((prevData) => {
        //           return prevData.map((item, i) =>
        //             i === row.index
        //               ? {
        //                   ...item,
        //                   status: e?.toString(),
        //                 }
        //               : item
        //           );
        //         });
        //       }}
        //       onBlur={(e) => {
        //         table.setEditingCell(null);
        //       }}
        //     />
        //   );
        // },
      },
      {
        accessorKey: "note",
        header: "Ghi chú",
        size: 400,
        Edit: ({ row, column, table }) => {
          return (
            <TextInput
              // autoFocus
              placeholder="Nhập ghi chú"
              // max={row.original.tonao}
              min={1}
              value={row._valuesCache[column.id]}
              onChange={(e) => {
                setListAdd((prevData) => {
                  return prevData.map((item, i) =>
                    i === row.index
                      ? {
                          ...item,
                          note: e.target.value,
                        }
                      : item,
                  );
                });
              }}
              onBlur={(e) => {
                table.setEditingCell(null);
              }}
            />
          );
        },
      },
    ],
    [listAdd, dataProducts, selectedProducts, dataRequestTransfer, opened],
  );

  const getColumnVisibility = (type: string) => {
    if (
      type === "DIEU_CHUYEN_CHI_NHANH" ||
      type === "DIEU_CHUYEN_NOI_BO" ||
      type === "XUAT_CONG_CU_DUNG_CU"
    ) {
      return {
        serial: false,
        poPrice: false,
      };
    } else if (
      type === "XUAT_HUY" ||
      type === "DIEU_CHUYEN_NOI_BO_SERIAL" ||
      type === "DIEU_CHUYEN_CHI_NHANH_SERIAL" ||
      type === "XUAT_DIEU_CHINH"
    ) {
      return {
        serial: true,
        poPrice: true,
      };
    }
    return {
      serial: true,
      poPrice: true,
    };
  };

  const openDeleteConfirmModal = (row: MRT_Row<dataOrderDetailTable>) => {
    return modals.openConfirmModal({
      title: "Bạn có chắc chắn xóa sản phẩm này?",
      children: (
        <Text size="lg" mt={15}>
          Hành động này có thể được hoàn tác khi được thêm mới.
        </Text>
      ),
      labels: { confirm: "Xóa", cancel: "Thoát" },
      confirmProps: { color: "red" },
      onConfirm: () => {
        const data = listAdd.filter((value) => {
          if (
            dataRequestTransfer.type === "DIEU_CHUYEN_CHI_NHANH" ||
            dataRequestTransfer.type === "DIEU_CHUYEN_NOI_BO" ||
            dataRequestTransfer.type === "XUAT_CONG_CU_DUNG_CU"
          ) {
            return value.itemId !== row.original.itemId;
          } else {
            return value.serial !== row.original.serial;
          }
        });
        setListAdd(data);
        if (
          dataRequestTransfer.type === "DIEU_CHUYEN_CHI_NHANH" ||
          dataRequestTransfer.type === "DIEU_CHUYEN_NOI_BO" ||
          dataRequestTransfer.type === "XUAT_CONG_CU_DUNG_CU"
        ) {
          setSelectedProducts((prevSelectedProducts) => {
            const newSelectedProducts = new Set(prevSelectedProducts);
            newSelectedProducts.delete(row.original.itemId);
            return newSelectedProducts;
          });
        } else {
          setSelectedProducts((prevSelectedProducts) => {
            const newSelectedProducts = new Set(prevSelectedProducts);
            newSelectedProducts.delete(row.original.serial);
            return newSelectedProducts;
          });
        }
      },
    });
  };

  const [height, setHeight] = useState(0);

  useEffect(() => {
    if (dataSerial !== undefined && dataSerial !== null) {
      fetchDataCreateRequestTransfer(dataSerial?.type);
    }
  }, [dataSerial]);

  useEffect(() => {
    if (dataRequestTransfer.type === "XUAT_TRA_NCC") {
      getDataVendor();
    } else {
      setDataVendorSelect([]);
      setDataVendorId([]);
    }
  }, [dataRequestTransfer.type]);

  useEffect(() => {
    if (dataRequestTransfer.toEmpId && dataRequestTransfer.toEmpId !== 0) {
      handleChangeValueInput(
        getValueById(
          dataRequestTransfer.toEmpId?.toString() ?? "",
          dataDepAndRole,
          "departmentId",
        ),
        "toDepartmentId",
      );
      handleChangeValueInput(
        getValueById(
          dataRequestTransfer.toEmpId?.toString() ?? "",
          dataDepAndRole,
          "roleId",
        ),
        "toRoleId",
      );
    } else {
      handleChangeValueInput(null, "toDepartmentId");
      handleChangeValueInput(null, "toRoleId");
    }
  }, [dataRequestTransfer.toEmpId]);

  useEffect(() => {
    if (
      dataRequestTransfer.toBranchId &&
      dataRequestTransfer.toBranchId !== 0
    ) {
      getDataEmpToBranch();
      getDataEmpManagerItem();
      getDetailBranch(dataRequestTransfer.toBranchId, "Bên nhập");
    } else {
      setDataEmpToBranch([]);
      setDataDepAndRole([]);
      setDataEmployeeManagerItem([]);
      setDetailToBranch(null);
    }
  }, [dataRequestTransfer.toBranchId]);

  useEffect(() => {
    if (
      dataRequestTransfer.fromBranchId &&
      dataRequestTransfer.fromBranchId !== null
    ) {
      getDetailBranch(dataRequestTransfer.fromBranchId, "Bên xuất");
    } else {
      setDetailFromBranch(null);
    }
  }, [dataRequestTransfer.fromBranchId]);

  useEffect(() => {
    if (dataRequestTransfer.fromInvId || valueDebounced.length > 2) {
      fetchItemSell();
    } else {
      table.setCreatingRow(null);
    }
  }, [dataRequestTransfer?.fromInvId, valueDebounced]);

  useEffect(() => {
    const fetchAllData = async () => {
      try {
        await Promise.all([fetchDataBranch(), getDataReasonRequestTransfer()]);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchAllData();
  }, []);

  useEffect(() => {
    const fectDataInv = async () => {
      if (dataRequestTransfer.toBranchId) {
        const toInv = await fetchdataInventory(dataRequestTransfer.toBranchId);
        setDataInventory((prev) => ({ ...prev, toInv: toInv }));
      } else {
        setDataInventory((prev) => ({ ...prev, toInv: [] }));
      }
      if (dataRequestTransfer.fromBranchId) {
        const formInv = await fetchdataInventory(
          dataRequestTransfer.fromBranchId,
        );
        setDataInventory((prev) => ({ ...prev, formInv: formInv }));
      } else {
        setDataInventory((prev) => ({ ...prev, formInv: [] }));
      }
    };
    fectDataInv();
  }, [dataRequestTransfer.toBranchId, dataRequestTransfer.fromBranchId]);

  // useEffect(() => {
  //   const invalidItems = listAdd.filter(
  //     (item) => item.primaryQuantity > (item.virtualQuantity ?? 0)
  //   );

  //   if (
  //     invalidItems.length > 0 &&
  //     dataRequestTransfer.type !== "XUAT_HUY" &&
  //     dataRequestTransfer.type !== "DIEU_CHUYEN_NOI_BO_SERIAL" &&
  //     dataRequestTransfer.type !== "DIEU_CHUYEN_CHI_NHANH_SERIAL" &&
  //     dataRequestTransfer.type !== "XUAT_DIEU_CHINH" &&
  //     dataRequestTransfer.type !== "XUAT_TRA_NCC"
  //   ) {
  //     setIsExceedQuantity(true);
  //     NotificationExtension.Fails(
  //       <>
  //         <Text>Số lượng sản phẩm yêu cầu vượt quá số lượng sẵn hàng.</Text>
  //         {invalidItems.map((item) => (
  //           <Text>
  //             Sản phẩm {item.itemCode} - {item.itemName}
  //           </Text>
  //         ))}
  //       </>
  //       // `Số lượng sản phẩm yêu cầu vượt quá số lượng tồn kho. Sản phẩm ${invalidItems[0].itemCode} - ${invalidItems[0].itemName}`
  //     );
  //   } else {
  //     setIsExceedQuantity(false);
  //   }
  // }, [listAdd]);

  useEffect(() => {
    if (dataRequestTransfer && dataRequestTransfer.deliveryPriorityLevel) {
      let deliveryTime = "";

      switch (dataRequestTransfer.deliveryPriorityLevel) {
        case "Giao hàng trong ngày":
          deliveryTime = dayjs().add(1, "day").format("YYYY-MM-DD[T]HH:mm:ss");
          break;
        case "Giao hàng nhanh 2h":
          deliveryTime = dayjs(new Date())
            .add(2, "hours")
            .format("YYYY-MM-DD[T]HH:mm:ss");
          break;
        case "Giao hàng tiêu chuẩn 3h":
          deliveryTime = dayjs(new Date())
            .add(3, "hours")
            .format("YYYY-MM-DD[T]HH:mm:ss");
          break;
        case "Khác":
          deliveryTime = dayjs().format("YYYY-MM-DD[T]HH:mm:ss");
          break;
        default:
          break;
      }

      setDataRequestTransfer((prevData) => ({
        ...prevData,
        deliveryTime: deliveryTime,
      }));
    }
  }, [dataRequestTransfer.deliveryPriorityLevel]);

  useEffect(() => {
    setDataRequestTransfer((prev) => ({
      ...prev,
      totalQuantity:
        listAdd && listAdd.length > 0
          ? listAdd.reduce((sum, item) => sum + item.primaryQuantity, 0)
          : 0,
      totalAmount:
        listAdd && listAdd.length > 0
          ? listAdd.reduce(
              (sum, item) => sum + item?.poPrice * item?.primaryQuantity,
              0,
            )
          : 0,
    }));
  }, [listAdd]);

  useEffect(() => {
    if (
      (dataRequestTransfer.fromInvId === null &&
        dataRequestTransfer.toInvId === null) ||
      (dataRequestTransfer.fromInvId?.toString() === "" &&
        dataRequestTransfer.toInvId?.toString() === "")
    ) {
      setTypeInv("");
    } else if (
      (dataRequestTransfer.type === "DIEU_CHUYEN_CHI_NHANH" ||
        dataRequestTransfer.type === "DIEU_CHUYEN_CHI_NHANH_SERIAL") &&
      (dataRequestTransfer.fromInvId !== null ||
        dataRequestTransfer.toInvId !== null) &&
      (dataRequestTransfer.fromInvId?.toString() !== "" ||
        dataRequestTransfer.toInvId?.toString() !== "")
    ) {
      if (
        dataRequestTransfer?.fromInvId !== null &&
        dataRequestTransfer.fromInvId?.toString() !== ""
      ) {
        const label = getValueById(
          dataRequestTransfer?.fromInvId?.toString() ?? "",
          dataInventory?.formInv,
          "type",
        );
        setTypeInv(label);
        handleChangeValueInput(label || "", "attribute7");
        form.setValues((prev) => ({
          ...prev,
          attribute7: label,
        }));
      } else {
        const label = getValueById(
          dataRequestTransfer?.toInvId?.toString() ?? "",
          dataInventory?.toInv,
          "type",
        );
        setTypeInv(label);
        handleChangeValueInput(label || "", "attribute7");
        form.setValues((prev) => ({
          ...prev,
          attribute7: label,
        }));
      }
    }
  }, [
    dataRequestTransfer.fromInvId,
    dataRequestTransfer.toInvId,
    dataRequestTransfer.type,
  ]);

  // useEffect(() => {
  //   if (
  //     typeInv.length > 0 &&
  //     dataRequestTransfer.type !== "DIEU_CHUYEN_NOI_BO" &&
  //     dataRequestTransfer.type !== "DIEU_CHUYEN_NOI_BO_SERIAL" &&
  //     dataRequestTransfer.type !== "XUAT_CONG_CU_DUNG_CU"
  //   ) {
  //     if (dataInventory?.toInv && Array.isArray(dataInventory.toInv)) {
  //       const foundItem = dataInventory.toInv.find((item) =>
  //         item.label.includes(typeInv)
  //       );
  //       if (foundItem) {
  //         handleChangeValueInput(foundItem.value || "", "toInvId");
  //         form.setValues((prev) => ({
  //           ...prev,
  //           toInvId: Number(foundItem.value),
  //         }));
  //       } else {
  //         handleChangeValueInput(null, "toInvId");
  //         form.setValues((prev) => ({
  //           ...prev,
  //           toInvId: 0,
  //         }));
  //       }
  //     }
  //   }
  // }, [typeInv, dataInventory]);

  // useEffect(() => {
  //   const timeoutId = setTimeout(() => {
  //     if (
  //       dataRequestTransfer.toBranchId !== null &&
  //       dataRequestTransfer.toBranchId !== undefined &&
  //       dataRequestTransfer.toBranchId !== 0 &&
  //       dataRequestTransfer.fromInvId !== null &&
  //       dataRequestTransfer.fromInvId?.toString() !== "" &&
  //       (dataRequestTransfer.toInvId === null ||
  //         dataRequestTransfer.toInvId?.toString() === "") &&
  //       (dataRequestTransfer.type === "DIEU_CHUYEN_CHI_NHANH" ||
  //         dataRequestTransfer.type === "DIEU_CHUYEN_CHI_NHANH_SERIAL") &&
  //       typeInv?.toString() !== "HB" &&
  //       typeInv?.toString() !== "SR"
  //     ) {
  //       NotificationExtension.Fails("Không tìm thấy kho tương ứng bên xuất !");
  //     }
  //   }, 300);

  //   // Cleanup function to clear timeout if dependencies change
  //   return () => clearTimeout(timeoutId);
  // }, [
  //   dataRequestTransfer.fromInvId,
  //   dataRequestTransfer.toBranchId,
  //   dataRequestTransfer.toInvId,
  //   dataInventory?.toInv,
  // ]);

  useEffect(() => {
    const date = new Date();
    date.setHours(date.getHours() + 7);
    setDataCreateDate(date.toISOString());
  }, []);

  useEffect(() => {
    if (dataSerial !== undefined) {
      const date = new Date();
      date.setHours(date.getHours() + 7);
      setDataCreateDate(date.toISOString());
    }
  }, [dataSerial]);

  useEffect(() => {
    if (
      dataRequestTransfer.type === "XUAT_CONG_CU_DUNG_CU" &&
      dataInventory?.toInv &&
      dataInventory?.toInv?.length > 0
    ) {
      const filterValue = dataInventory?.toInv?.filter((item: any) =>
        item.label?.includes("_TS"),
      );

      if (filterValue.length > 0) {
        const label = getValueById(
          filterValue[0]?.value ?? "",
          dataInventory?.toInv,
          "label",
        );
        form.setValues((prev) => ({
          ...prev,
          toInvId: Number(filterValue[0].value),
        }));
        handleChangeValueInput(Number(filterValue[0].value) || "", "toInvId");
        handleChangeValueInput(
          label?.match(/\((.*?)\)/)?.[1] ?? "",
          "attribute8",
        );
      } else {
        NotificationExtension.Fails("Chi nhánh không có kho tài sản !");
        handleChangeValueInput(null, "toInvId");
        handleChangeValueInput(null, "attribute8");
      }
    }
  }, [
    dataRequestTransfer.type,
    dataRequestTransfer.fromBranchId,
    dataInventory?.toInv,
  ]);

  useHotkeys([
    [
      "Enter",
      () => {
        if (
          dataRequestTransfer?.type !== "DIEU_CHUYEN_CHI_NHANH" &&
          dataRequestTransfer?.type !== "DIEU_CHUYEN_NOI_BO" &&
          dataRequestTransfer?.type !== "XUAT_CONG_CU_DUNG_CU"
        ) {
          if (
            dataProducts.length > 1 ||
            selectedProducts.has(dataProducts[0].serial)
          ) {
            return;
          } else {
            handleSelectProduct(dataProducts[0], rowIndex);
            setValueDebounced("");
            table.setCreatingRow(null);
            setRowIndex((prevIndex) => prevIndex + 1);
          }
        } else {
          if (
            dataProducts.length > 1 ||
            selectedProducts.has(dataProducts[0].itemId)
          ) {
            return;
          } else {
            handleSelectProduct(dataProducts[0], rowIndex);
            setValueDebounced("");
            table.setCreatingRow(null);
            setRowIndex((prevIndex) => prevIndex + 1);
          }
        }
      },
    ],
    [
      "Ctrl + S",
      () => {
        handleCreateRequestTransfer(false);
      },
    ],
    [
      "Ctrl + Q",
      () => {
        handleCreateRequestTransfer(true);
      },
    ],
    [
      "Ctrl + I",
      () => {
        handleOpenFileDrop();
      },
    ],
  ]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 160 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (75 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);

  const table = useMantineReactTable<dataOrderDetailTable>({
    columns,
    data: listAdd,
    positionToolbarAlertBanner: "bottom",
    createDisplayMode: "row",
    editDisplayMode: "cell",
    enableEditing: true,
    enableRowActions: true,
    enableColumnActions: false,
    enableColumnOrdering: false,
    enableBatchRowSelection: true,
    onCreatingRowCancel: () => setValidationErrors({}),
    onEditingRowCancel: () => setValidationErrors({}),
    positionActionsColumn: "last",
    renderTopToolbar: () => (
      <Flex
        gap="md"
        justify={{ sm: "flex-start" }}
        wrap="wrap"
        align="center"
        direction="row"
        m={"16px 16px 0px 16px"}
      >
        <Button
          leftSection={<IconPlus size={14} />}
          variant="outline"
          color="blue"
          size="xs"
          onClick={() => {
            setOpened(true);
            if (
              dataRequestTransfer.type === "XUAT_HUY" ||
              dataRequestTransfer.type === "XUAT_DIEU_CHINH"
            ) {
              if (
                dataRequestTransfer.fromBranchId &&
                dataRequestTransfer.fromBranchId !== 0 &&
                dataRequestTransfer.fromInvId &&
                dataRequestTransfer.fromInvId !== 0 &&
                dataRequestTransfer.toBranchId &&
                dataRequestTransfer.toBranchId !== 0
              ) {
                table.setCreatingRow(true);
              } else {
                NotificationExtension.Fails(
                  "Vui lòng chọn đầy đủ thông tin kho và chi nhánh bên xuất và bên nhận",
                );
              }
            } else if (dataRequestTransfer.type === "XUAT_TRA_NCC") {
              if (
                dataRequestTransfer.fromBranchId &&
                dataRequestTransfer.fromBranchId !== 0 &&
                dataRequestTransfer.fromInvId &&
                dataRequestTransfer.fromInvId !== 0
              ) {
                table.setCreatingRow(true);
              } else {
                NotificationExtension.Fails(
                  "Vui lòng chọn đầy đủ thông tin kho và chi nhánh bên xuất",
                );
              }
            } else {
              if (
                dataRequestTransfer.fromBranchId &&
                dataRequestTransfer.fromBranchId !== 0 &&
                dataRequestTransfer.fromInvId &&
                dataRequestTransfer.fromInvId !== 0 &&
                dataRequestTransfer.toBranchId &&
                dataRequestTransfer.toBranchId !== 0 &&
                dataRequestTransfer.toInvId &&
                dataRequestTransfer.toInvId !== 0
              ) {
                table.setCreatingRow(true);
              } else {
                NotificationExtension.Fails(
                  "Vui lòng chọn đầy đủ thông tin kho và chi nhánh bên xuất và bên nhận",
                );
              }
            }
          }}
          disabled={dataRequestTransfer.type === null}
        >
          Thêm sản phẩm (F11)
        </Button>
        {/* <Text size="xs" fs={"italic"} c={"gray"}>
          hoặc
        </Text>
        <Menu>
          <Menu.Target>
            <TextInput
              placeholder="Quét serial sản phẩm"
              size="xs"
              value={scanSerial}
              onChange={(e) => setScanSerial(e.currentTarget.value)}
              disabled={
                dataRequestTransfer.type === "DIEU_CHUYEN_CHI_NHANH" ||
                dataRequestTransfer.type === "DIEU_CHUYEN_NOI_BO"
              }
            />
          </Menu.Target>
          <Menu.Dropdown>
            <TableSelect
              dataProducts={dataProducts}
              onSelectProduct={(product) =>
                handleSelectProduct(product, row.index)
              }
              rowIndex={row.index}
            />
          </Menu.Dropdown>
        </Menu> */}
      </Flex>
    ),

    renderRowActions: ({ row, table }) => (
      <Flex gap="4">
        <Tooltip label="Xoá sản phẩm">
          <ActionIcon variant="outline" color="red">
            <IconTrash onClick={() => openDeleteConfirmModal(row)} />
          </ActionIcon>
        </Tooltip>
      </Flex>
    ),

    renderTopToolbarCustomActions: ({ table }) => (
      <>
        <Flex
          gap="md"
          justify="flex-start"
          align="center"
          direction="row"
          wrap="wrap"
          mb={"xs"}
          style={{ opacity: 0 }}
        ></Flex>
      </>
    ),

    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    // localization: _localizationInventory,
    getRowId: (row) => row.itemId?.toString(),
    mantineTableContainerProps: {
      style: { maxHeight: height - 100, minHeight: height - 100 },
    },
    initialState: {
      columnPinning: {
        left: ["mrt-row-select"],
        right: ["mrt-row-actions"],
      },
      columnVisibility: getColumnVisibility(dataRequestTransfer.type ?? ""),
      density: "xs",
    },

    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    manualSorting: false,
    rowCount,
    mantineTableBodyCellProps: ({ row }) => ({
      onDoubleClick: () => {
        table.setCreatingRow(null);
      },
      onClick: () => setOpened(true),
      style: styleCellTable(row),
    }),
    enablePagination: false,
    enableBottomToolbar: false,

    state: {
      isLoading,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,

      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,

    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
  });

  React.useEffect(() => {
    const newColumnVisibility = getColumnVisibility(
      dataRequestTransfer.type ?? "",
    );
    if (table) {
      table.setColumnVisibility(newColumnVisibility);
    }
  }, [dataRequestTransfer.type, table]);

  React.useEffect(() => {
    if (!opened) {
      table.setCreatingRow(null);
    }
  }, [opened]);

  //#endregion
  return (
    <Box>
      <Modal
        opened={openModals}
        onClose={() => setOpenModal(false)}
        title={<Title order={4}>Vui lòng chọn Sheet từ file excel</Title>}
      >
        {sheetNames.map((sheet, index) => (
          <Checkbox
            mt={15}
            key={index}
            label={<Text fw={500}>{sheet}</Text>}
            checked={selectedSheets.includes(sheet)}
            onChange={(e) => {
              setSelectedSheets(e.target.checked ? [sheet] : []); //chỉ chọn 1
              // setSelectedSheets((prev) =>
              //   e.target.checked
              //     ? [...prev, sheet]   //Cho chọn nhiều
              //     : prev.filter((item) => item !== sheet)
              // );
            }}
          />
        ))}
        <Group mt={15} justify="flex-end">
          <Button
            leftSection={<IconCheck size={16} />}
            onClick={handleSheetSelection}
            color="#228be6"
            variant="filled"
          >
            Xác nhận
          </Button>
        </Group>
      </Modal>
      <div ref={headerRef}>{titleSell()}</div>
      <PanelGroup direction="horizontal" id="group">
        <Panel defaultSize={35} minSize={25} maxSize={75}>
          <Card
            h={height}
            p={0}
            shadow="sm"
            radius="md"
            withBorder
            style={{ overflow: "auto" }}
          >
            {mainRequestTransfer()}
          </Card>
        </Panel>
        <PanelResizeHandle id="resize-handle" style={{ width: "5px" }} />
        <Panel defaultSize={65} minSize={25} maxSize={75}>
          <MantineReactTable table={table} />
          <Flex justify={"start"} gap={"xs"} h={50} mt={5}>
            <Flex
              direction={"column"}
              align={"center"}
              justify={"center"}
              bd={"1px solid #DEE2E6"}
              style={{ borderRadius: "10px" }}
              gap={"xs"}
              w={150}
            >
              <Text size="14px" fw={"bold"}>
                Tổng số lượng
              </Text>
              <Text size="13px" fw={"bold"} c={"red"}>
                {listAdd && listAdd.length > 0
                  ? listAdd.reduce((sum, item) => sum + item.primaryQuantity, 0)
                  : 0}
              </Text>
            </Flex>
            <Flex
              direction={"column"}
              align={"center"}
              justify={"center"}
              bd={"1px solid #DEE2E6"}
              style={{ borderRadius: "10px" }}
              gap={"xs"}
              w={150}
            >
              <Text size="14px" fw={"bold"}>
                Tổng thành tiền
              </Text>
              <Text size="13px" fw={"bold"} c={"red"}>
                {listAdd && listAdd.length > 0
                  ? listAdd
                      .reduce(
                        (sum, item) =>
                          sum + item?.poPrice * item?.primaryQuantity,
                        0,
                      )
                      .toLocaleString()
                  : 0}{" "}
                đ
              </Text>
            </Flex>
          </Flex>
        </Panel>
      </PanelGroup>
    </Box>
  );
};
export default CreateRequestTransfer;
